/**
 * 首页三栏布局：compact / normal / wide 三档，供 App.vue 与各页面共用。
 */
export function getLayoutProfile() {
  const w = window.innerWidth;
  const h = window.innerHeight;
  const compact = h <= 800 || w <= 1280;
  const wide = w > 1920 && !compact;
  return { w, h, compact, wide };
}

export function getHomeLayoutRatio(compact, wide) {
  if (compact) {
    // 小屏：会话列表多留一点，快捷回复收窄
    return { client: 0.38, chat: 0.5, quick: 0.12 };
  }
  if (wide) {
    return { client: 0.3, chat: 0.5, quick: 0.16 };
  }
  return { client: 0.32, chat: 0.55, quick: 0.13 };
}

export function getQuickPanelWidth(boxWidth, compact, wide) {
  const ratio = getHomeLayoutRatio(compact, wide);
  const minPx = compact ? 160 : 240;
  const maxPx = compact ? 200 : wide ? 380 : 320;
  return Math.min(
    Math.max(Math.floor(boxWidth * ratio.quick), minPx),
    maxPx
  );
}

export function getHomeLayoutConstraints(boxWidth, isLeft, compact, wide) {
  const ratio = getHomeLayoutRatio(compact, wide);
  const quickMin = getQuickPanelWidth(boxWidth, compact, wide);
  const clientCap = compact ? 460 : wide ? 560 : 500;
  const chatCap = compact ? 420 : wide ? 960 : 800;

  if (isLeft) {
    return {
      minLeft: quickMin,
      minRight: Math.min(Math.floor(boxWidth * ratio.chat), chatCap),
      quickMin,
    };
  }
  return {
    minLeft: Math.min(Math.floor(boxWidth * ratio.client), clientCap),
    minRight: quickMin,
    quickMin,
  };
}

/** 最左侧功能栏宽度：按分辨率阶梯放大，避免大屏显得过窄 */
export function getSidebarWidth(w, compact) {
  if (compact) {
    return w <= 1100 ? 43 : 48;
  }
  if (w <= 1440) return 57;
  if (w <= 1680) return 64;
  if (w <= 1920) return 72;
  if (w <= 2560) return 80;
  return 88;
}

export function applyLayoutCssVars(html) {
  if (!html) {
    html = document.documentElement;
  }
  const { w, compact, wide } = getLayoutProfile();

  if (compact) {
    html.setAttribute("data-compact", "1");
    html.removeAttribute("data-wide");
  } else {
    html.removeAttribute("data-compact");
    if (wide) {
      html.setAttribute("data-wide", "1");
    } else {
      html.removeAttribute("data-wide");
    }
  }

  const sidebarW = getSidebarWidth(w, compact);
  const quickMinPct = compact ? 11 : wide ? 16 : 13;
  const quickMinPx = compact ? 160 : 240;
  const quickMaxPx = compact ? 200 : wide ? 380 : 320;
  const mydiaW = compact ? 116 : wide ? Math.min(180, Math.floor(w * 0.08)) : 150;

  // 侧栏内图标/头像随栏宽一起放大
  let sidebarAvatar = 30;
  let sidebarIcon = 20;
  let sidebarNickW = 52;
  if (compact) {
    sidebarAvatar = 19;
    sidebarIcon = 12;
    sidebarNickW = 40;
  } else if (sidebarW >= 80) {
    sidebarAvatar = 36;
    sidebarIcon = 24;
    sidebarNickW = 72;
  } else if (sidebarW >= 72) {
    sidebarAvatar = 34;
    sidebarIcon = 22;
    sidebarNickW = 64;
  } else if (sidebarW >= 64) {
    sidebarAvatar = 32;
    sidebarIcon = 22;
    sidebarNickW = 56;
  }

  html.style.setProperty("--sidebar-w", `${sidebarW}px`);
  html.style.setProperty("--sidebar-avatar", `${sidebarAvatar}px`);
  html.style.setProperty("--sidebar-icon", `${sidebarIcon}px`);
  html.style.setProperty("--sidebar-nick-w", `${sidebarNickW}px`);
  html.style.setProperty("--quick-min-pct", `${quickMinPct}%`);
  html.style.setProperty("--quick-min-px", `${quickMinPx}px`);
  html.style.setProperty("--quick-max-px", `${quickMaxPx}px`);
  html.style.setProperty("--mydia-w", `${mydiaW}px`);

  return { compact, wide };
}
